module.exports = __webpack_public_path__ + "static/media/family-in-new-house-square.1a8b8386.jpg";